// extracted by mini-css-extract-plugin
export default {"neonButton":"NeonButton_neonButton__5Njxg","logo":"NeonButton_logo__9yl1O"};